<template>

    <section class="hero flex">
        <div class="hero-body">
            <div class="container has-text-centered">

                <h1 class="survey_title title is-size-1">
                    {{ $t('modules.candidates.survey.title') }}
                </h1>


                <div class="first_part" v-if="currentSurvey == 'sight1'">

                    <transition name="survey-fade">
                        <div class="sight1_desc" v-if="sight1Status == 'pending' ">
                            <div class="title">{{ $t('modules.candidates.survey.firstPart') }}</div>

                            <button class="button is-info is-outlined" @click="sight1Status = 'running'">
                                {{ $t('modules.candidates.survey.beginSurveyButton') }}
                            </button>

                            <div class="legal_notice">
                                <div class="legal_title is-size-3 has-text-centered">{{ $t('modules.candidates.survey.important') }}</div>
                                <span v-html="$t('modules.candidates.survey.legalNotice')"></span>
                            </div>
                        </div>
                    </transition>

                    <transition name="survey-fade">
                        <Sight1Survey v-if=" sight1Status == 'running' " @surveyCompleted="setSight1Completed" />
                    </transition>

                </div>

                <div class="second_part" v-if="currentSurvey == 'sight2'">

                    <transition name="survey-fade">
                        <div class="sight1_desc" v-if="sight2Status == 'pending' ">
                            <div class="title">
                                {{ $t('modules.candidates.survey.secondPart') }}
                            </div>
                            <p>{{ $t('modules.candidates.survey.secondPartNotice') }}</p>
                            <br>
                            <button class="button is-info is-outlined" @click="sight2Status = 'running'">{{ $t('modules.candidates.survey.beginSecondPartButton') }}</button>
                        </div>
                    </transition>

                    <transition name="survey-fade">
                        <Sight2Survey v-if=" sight2Status == 'running' " @surveyCompleted="setSight2Completed" />
                    </transition>

                </div>

                <div class="third_part" v-if="currentSurvey == 'finish'">
                    <div class="sight1_desc">

                        <div class="title">
                            {{ $t('modules.candidates.survey.finishTitle') }}
                        </div>

                        <div class="finish_notice">

                            <p>{{ $t('modules.candidates.survey.finishNotice1') }}</p>
                            <p>{{ $t('modules.candidates.survey.finishNotice2') }}</p>
                        </div>

                        <div class="control has-text-centered genre_select">
                            <div class="label">{{ $t('modules.candidates.survey.formGenreLabel') }}:</div>
                            <div class="select">
                                <select v-model="genre">
                                    <option value="men">{{ $t('modules.candidates.survey.formMenVal') }}</option>
                                    <option value="women">{{ $t('modules.candidates.survey.formWomenVal') }}</option>
                                </select>
                            </div>
                        </div>

                        <button class="save_survey_btn button is-rounded is-outlined is-info" @click="saveEval" v-if="!evalSaved">
                            {{ $t('modules.candidates.survey.validateButton') }}
                        </button>

                        <div v-else>
                            {{ $t('modules.candidates.survey.thanks') }}
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </section>

</template>

<script>
import Sight1Survey from './sight1Survey'
import Sight2Survey from './sight2Survey'

export default {
    name: 'CandidateSurvey',
    components: {
        Sight1Survey,
        Sight2Survey
    },
    beforeCreate(){
        this.$store.dispatch('CandidateStore/getSurveys')
    },
    data(){
        return {
            currentSurvey: 'sight1',
            sight1Status: 'pending',
            sight2Status: 'pending',
            startTime: performance.now(),
            endTime: null,
            elapsedTime: null,
            genre: 'men',
            evalSaved: false
        }
    },
    methods: {
        setSight1Completed(surveyName){
            this.currentSurvey = 'sight2'
            this.sight1Status = 'completed'
        },
        setSight2Completed(surveyName){
            this.currentSurvey = 'finish'
            this.sight2Status = 'completed'
            this.endTime = performance.now()
            this.elapsedTime = this.endTime - this.startTime
            // send data to server
        },
        saveEval(){
            this.evalSaved = true
            this.$store.dispatch('CandidateStore/saveEval', {elapsedTime: this.elapsedTime, genre: this.genre}).then(() => {
            })
        }
    }
}

</script>

<style lang="scss">
.survey_title{
    margin-top: 30px;
}
.sight1_desc{
    padding-top: 100px;
    position: relative;
    p{
        width: 100%;
        max-width: 700px;
        margin: auto;
    }
}

.survey_order{
    max-width: 800px;
    text-align: center;
    margin: auto;
    font-size: 1.25rem;
    padding: 30px 0;
}
.question_block{
    background: $white-ter;
    padding: 30px 0;
}

.survey_question{
    margin-bottom: 30px;
    .survey_label{
        font-weight: 300!important;
        margin: 0!important;
    }
    .survey_radio_response_container{
        display: flex;
        justify-content: center;
        align-items: center;
        .rounded_radio{
            input{
                opacity: 0;
                height: 1px;
                width: 1px;
            }
            label{
                cursor: pointer;
                background: $grey-lighter;
                height: 52px;
                width: 52px;
                text-align: center;
                margin: 0px 16px;
                border-radius: 100%;
                line-height: 52px;
                font-size: 1.5rem;
                font-weight: 300;
                transition: .3s all;
            }
            input:checked + label{
                box-shadow: inset 0 0 100px $info;
                color: $white;
            }
        }
    }
}
.genre_select{
    margin-bottom: 30px;
    select{
        width: 300px;
    }
}
.finish_notice{
    margin: 30px 0;
    font-size: 1.2rem;
}
.legal_notice{
    .legal_title{
        font-weight: 500;
    }
    width: 100%;
    max-width: 580px;
    text-align: justify;
    margin: 30px auto;
}

@media screen and (max-width: 649px) {
    .survey_title.is-size-1{
        font-size: 2.75rem!important;
    }
}
</style>